import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import './PhoneNumberInput.css';

interface PhoneNumberInputProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  placeholder?: string;
  required?: boolean;
  className?: string;
}

const PhoneNumberInput = ({
  value,
  onChange,
  error,
  placeholder = "+251912345678",
  required = false,
  className = "",
}: PhoneNumberInputProps) => {
  const handleChange = (phoneValue: string | undefined) => {
    onChange(phoneValue || '');
  };

  return (
    <div className={`PhoneInput ${error ? 'error' : ''} ${className}`}>
      <PhoneInput
        international
        defaultCountry="ET"
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        required={required}
        className="w-full"
      />
      {error && (
        <div className="mt-1 text-xs text-red-500 dark:text-red-400 animate-fade-in">
          {error}
        </div>
      )}
    </div>
  );
};

export default PhoneNumberInput; 
